import { computed, defineComponent } from '@vue/composition-api';
const STEP_KEYS = ['ask', 'compare', 'pay'];
export default defineComponent({
    props: {
        blok: {
            type: Object,
            default: () => ({})
        }
    },
    setup(props, context) {
        const { root } = context;
        const t = (key) => root.$i18n.t(key);
        return {
            title: computed(() => props.blok?.title || t('home.q4s.steps.title')),
            lead: computed(() => props.blok?.lead || t('home.q4s.steps.lead')),
            steps: computed(() => STEP_KEYS.map((key) => ({
                key,
                title: t(`home.q4s.steps.${key}.title`),
                text: t(`home.q4s.steps.${key}.text`)
            })))
        };
    }
});
